export default __webpack_public_path__ + "static/media/Threeh 1.3417edc6.jpg";